import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { PageRoutes } from '../../enums/enums';
import type { GhostPostSummaryItemModel } from '../../models/GhostPostSummaryListModel';
import ImageWrapper from '../ImageWrapper';

interface FakeableGhostPostModel extends Omit<GhostPostSummaryItemModel, 'title' | 'featureImage'> {
  title?: string | React.ReactNode;
  featureImage?: string | React.ReactNode;
}

interface GhostPostGalleryButtonProps {
  post: FakeableGhostPostModel;
  pathPrefix: string;
  onClick?: () => void;
  displayRules?: string;
}

export default function GhostPostGalleryLinkButton({
  post,
  onClick,
  pathPrefix,
  displayRules
}: GhostPostGalleryButtonProps) {
  const navigate = useNavigate();

  return (
    <Link
      to={`${pathPrefix}${pathPrefix ? '/' : ''}${post.slug}`}
      className={
        'rounded-2xl relative overflow-hidden ' +
        `relative text-left bg-teal-2 bg-opacity-0 hover:bg-opacity-5 mb-4 ${displayRules ?? 'flex'}`
      }
      onClick={onClick}
    >
      <div className={'flex-start w-full text-slate-800 hover:text-teal'}>
        <div className={'m-2 mb-0 aspect-video rounded-xl overflow-hidden'}>
          {typeof post.featureImage === 'string' ? (
            <ImageWrapper
              src={post.featureImage}
              alt={post.featureImageCaption ?? ''}
              className={'w-full h-full text-2xl aspect-[5/3]'}
              borderOnFail
            />
          ) : (
            post.featureImage
          )}
        </div>
        <div className={'p-4 font-normal flex flex-col gap-1'}>
          {post.tags && post.tags.length > 0 && (
            <div className={'text-xs uppercase'}>
              {post.tags.map((tag, index) => {
                return (
                  <span
                    key={tag.slug}
                    className={'like-anchor'}
                    onClick={(ev) => {
                      ev.preventDefault();
                      navigate(
                        `../../${PageRoutes.DASHBOARD_OUTLET}/${PageRoutes.NEWS_OUTLET}/${PageRoutes.NEWS_ARTICLES_OUTLET}?tag=${tag.slug}`
                      );
                    }}
                  >
                    <span>{tag.name}</span>
                    {index !== (post.tags?.length ?? 0) - 1 && <span>, </span>}
                  </span>
                );
              })}
            </div>
          )}
          <h3 className={'text-[1.4rem] break-words'}>{post.title}</h3>

          <div className="text-gray-800 text-sm mt-3 leading-relaxed"></div>
        </div>
      </div>
    </Link>
  );
}
